import { createFileRoute } from "@tanstack/react-router";
import { SchemaViewer } from "@/pages/3d/visualization/SchemaViewer";

export const Route = createFileRoute("/demo/3d/visualization/schema-viewer")({
  component: SchemaViewer,
});
